<!-- eslint-disable -->
<template lang="pug">
    .playground(:style="stylePlayground")
        img.scanner-image(
            v-for="item in items"
            :src="item.value | apiFile" 
            :style="styleScannerImage" 
            :class="classSearchItem(item)" 
            @click="onSelectElement(item)"
        )
</template>

<script>
    export default {
        props: {
            value: Array,
            itemsToRemember: Array,
            allItems: Array,
            memorized: Boolean,
            windowWidth: Number,
            shakedItems: Array,
        },
        computed: {
            items() {
                return this.memorized ? this.allItems : this.itemsToRemember;
            },
            size() {
                return Math.ceil(this.items.length ** 0.5);
            },
            stylePlayground() {
                return {
                    'grid-template-columns': `repeat(${this.size}, 1fr)`,
                };
            },
            styleScannerImage() {
                let maxWidth = '100%';
                if (this.size === 6) {
                    if (this.windowWidth >= 1660) {
                        maxWidth = '150px';
                    }
                } else if (this.size === 5) {
                    if (this.windowWidth >= 1560) {
                        maxWidth = '170px';
                    }
                } else if (this.size === 4) {
                    if (this.windowWidth >= 1480) {
                        maxWidth = '200px';
                    }
                } else if (this.size === 3) {
                    if (this.windowWidth >= 1200) {
                        maxWidth = '200px';
                    }
                } else if (this.size === 2) {
                    if (this.windowWidth >= 1200) {
                        maxWidth = '330px';
                    }
                }
                if (!this.memorized) {
                    return {
                        'pointer-events': 'none',
                        'max-width': maxWidth,
                    };
                }
                return '';
            },
        },
        methods: {
            classSearchItem(item) {
                return {
                    'scanner-image-selected': this.value.includes(item),
                    shake: this.shakedItems.includes(item),
                };
            },
            onSelectElement(item) {
                if (this.memorized) {
                    const index = this.value.indexOf(item);
                    const result =
                        index === -1
                            ? [...this.value, item]
                            : [...this.value.slice(0, index), ...this.value.slice(index + 1)];
                    this.$emit('input', result);
                    this.$emit('clearShakedItems');
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    .playground {
        display: grid;
        gap: calc(100vw / 100 + 2px);
        img.scanner-image {
            cursor: pointer;
            border-radius: calc(100vw / 150 + 3px);
            border-width: 2px;
            border-style: solid;
            border-color: $hsl-color-gray-92;
            &.scanner-image-selected {
                border-color: $hsl-color-green-58;
            }
            @include media($lg) {
                border-width: 3px;
            }
        }
    }


    td:empty {
        visibility: hidden;
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
